import Alpine from 'alpinejs'; // Alpine 전역 + 시작
import htmx from 'htmx.org'; // htmx 전역

// Import Alpinejs plugins
import mask from '@alpinejs/mask';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import sort from '@alpinejs/sort';

// SSE(Server-sent-event) 확장 추가
import 'htmx-ext-sse';

// import custom directive
import tooltip from './plugins/tooltip.js';

// [중요] Import custom alpinejs plugin
import registerComponents from './plugins/index.js';

// Import days plugin
import dayjs from 'dayjs'

// 항목 수정 모달 → SMS 팝업 문안 빌더($sms.open/progress/work/cost/sugum, 2026-09-16)
import * as smsText from './plugins/smsText.js';

// 모바일 쓰기 화면 공용 fetch 헬퍼($mapi — 세션 만료 시 /m/login, 2026-09-18 Phase G)
import mapi from './plugins/mobileApi.js';

// 목록 검색 폼(GET) 텍스트 입력 앞뒤 공백 제거 — document 위임, 템플릿 무수정(2026-10-12)
import installSearchTrim from './plugins/searchTrim.js';


// Alpine plugin 선언
Alpine.plugin(mask);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(sort);
Alpine.plugin(tooltip);

// [!!] custom 컴포넌트 등록
registerComponents(Alpine);

// 위 store 예제를 persist 로 바꾼 것
Alpine.store('shared', {
    message: Alpine.$persist('Hello from store').as('shared-message'),
    count: Alpine.$persist(0).as('shared-count'),
    increment() { this.count++ }
})

// 재사용 가능한 컴포넌트 정의 - 테스트 용
Alpine.data('counter', (initialCount = 0) => ({
    count: initialCount,
    increment() { this.count++ },
    decrement() { this.count-- },
    reset() { this.count = initialCount }
}));

// Alpine magic 플러그인 - now
Alpine.magic('now', () => {
    return () => dayjs().format('YYYY-MM-DD HH:mm:ss')
})

// Alpine magic - $sms : 수정 모달의 [SMS] 버튼이 폼 현재값으로 문안을 만들어 /sms/popup 새 창을 연다(레거시 ico_sms 미러)
Alpine.magic('sms', () => smsText);

// Alpine magic - $mapi : 모바일 폼(/m/work/form, /m/timesheet/form)이 데스크톱 JSON API 를 호출할 때 쓰는 fetch 래퍼
Alpine.magic('mapi', () => mapi);

// Custom Directive
Alpine.directive('uppercase', el => {
    el.textContent = el.textContent.toUpperCase()
});

// 검색 폼 trim 리스너 설치(submit capture + focusout)
installSearchTrim();

window.Alpine = Alpine;
window.htmx = htmx;
window.dayjs = dayjs;

Alpine.start();

// (선택) Spring Security CSRF 자동 부착
document.body.addEventListener('htmx:configRequest', (e) => {
    const t = document.querySelector('meta[name="_csrf"]')?.content;
    const h = document.querySelector('meta[name="_csrf_header"]')?.content;
    if (t && h) e.detail.headers[h] = t;
});
